import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 12px;
	padding: 30px;
	margin-bottom: 20px;
`;

export const LoadingImage = styled.img`
	width: ${(props) => (props.width ? `${props.width}px` : '30px')};
	max-width: auto;
`;
